import React, { useState, useMemo, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Lock, History } from '@material-ui/icons';
import { UnidataTable, Modal } from '~/components';

import { t } from '~/helpers';

import {
  operacaoBloqueioVeiculoPreFaturaGeradaInRequest,
  deleteOperacaoBloqueioVeiculoPreFaturaGerada,
  findOperacaoBloqueioVeiculoPreFaturaGerada,
  recordFiltering,
} from '~/store/modules/OperacaoBloqueioVeiculoPreFaturaGerada/actions';

import DetalhePreFaturaGerada from './components/DetalhePreFaturaGerada';

import AdmFormPreFaturaGerada from './components/AdmFormPreFaturaGerada';

function OperacaoBloqueioVeiculoPreFaturaGeradaList() {
  const dispatch = useDispatch();

  const buttons = [];

  const [loading, setLoading] = useState(false);

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const operacaobloqueioveiculoprefaturagerada = useSelector(
    (state) => state.operacaobloqueioveiculoprefaturagerada
  );

  const detalhePreFaturaGeradaRef = useRef(null);

  const admFormPreFaturaGerada = useRef(null);

  // async function handleUpdate() {
  //   await dispatch(
  //     recordFiltering(operacaobloqueioveiculoprefaturagerada.params)
  //   );
  // }

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(operacaobloqueioveiculoprefaturagerada.params));
  }, [operacaobloqueioveiculoprefaturagerada.params]);

  const header = useMemo(
    () => [
      //const header = [
      {
        id: 'orga_nome',
        label: 'Nome do Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_sigla',
        label: 'Sigla',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'fatu_codigo',
        label: 'Pré-fatura',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'fatu_periodo_str',
        label: 'Período',
        filter: {
          type: 'text',
        },
        align: 'center',
      },

      {
        id: 'fatu_status_str',
        label: 'Status',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
    ],
    []
  );

  const headerbuttons = useMemo(
    () => [
      buttons.push({
        title: 'Detalhe Veículos Bloqueados na Pré-fatura',
        action: (value) =>
          detalhePreFaturaGeradaRef.current.handleOpenModal({ data: value }),
        icon: <History />,
      }),

      buttons.push({
        title: 'Bloquear/Desbloquear veículo da pré fatura',
        action: (value) =>
          admFormPreFaturaGerada.current.handleOpenModal({ data: value }),
        icon: <Lock />,
      }),
    ],
    [operacaobloqueioveiculoprefaturagerada, itemSelecionado]
  );

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaobloqueioveiculoprefaturagerada]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="fatu_codigo ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        find={findOperacaoBloqueioVeiculoPreFaturaGerada}
        redux={operacaobloqueioveiculoprefaturagerada}
        read={recordFiltering}
        actions={buttons}
        detach="veic_placa"
        onRow={(values) => registroSelecionado(values)}
        view="VW_FATURAMENTO"
        reportTitle="Bloqueio Veículo Pré-Fatura Gerada"
      />
      {/* <Tabela
        read={operacaoBloqueioVeiculoPreFaturaGeradaInRequest}
        remove={deleteOperacaoBloqueioVeiculoPreFaturaGerada}
        state={operacaobloqueioveiculoprefaturagerada}
        header={header}
        noCreate
        noEdition
        headerMobile="veic_placa"
        unique={['veic_placa']}
        findItem={findOperacaoBloqueioVeiculoPreFaturaGerada}
        recordFilter={recordFiltering}
        buttons={buttons}        
        onCallback={(values) => registroSelecionado(values)}
      /> */}
      <Modal
        ref={detalhePreFaturaGeradaRef}
        //form
        disableBackdropClick
        disableEscapeKeyDown
        component={DetalhePreFaturaGerada}
        title="Veículos Bloqueados na Pré-fatura"
        loading={loading}
        maxWidth="sm"
        actions={[
          {
            label: t('s.geral.botaofechar'),
            callback: () =>
              detalhePreFaturaGeradaRef.current.handleCloseModal(),
            color: 'secondary',
          },
        ]}
      />
      <Modal
        ref={admFormPreFaturaGerada}
        //form
        disableBackdropClick
        disableEscapeKeyDown
        component={AdmFormPreFaturaGerada}
        title="Bloquear/Desbloquear veículo da pré fatura"
        loading={loading}
        maxWidth="sm"
        //form
        actions={[
          {
            label: t('s.geral.botaofechar'),
            callback: () => admFormPreFaturaGerada.current.handleCloseModal(),
            color: 'secondary',
          },
        ]}
      />
    </>
  );
}

export default OperacaoBloqueioVeiculoPreFaturaGeradaList;
